import { Popover, RadioGroup } from '@headlessui/react'
import classNames from 'classnames'
import {
    MdKeyboardArrowUp,
    MdLockOpen,
    MdLockOutline,
    MdOutlineBlock,
    MdOutlineCheckCircleOutline,
    MdOutlinePinInvoke,
    MdOutlineSearch,
} from 'react-icons/md'
import {
    Container,
    Header,
    SolicitacaoContainer,
    Filter,
    Table,
    Option,
} from './styles'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {
    BsCheckCircle,
    BsFilter,
    BsReceiptCutoff,
    BsBuilding,
    BsPlus,
} from 'react-icons/bs'
import { IoMdKey } from 'react-icons/io'
import { FormEvent, useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import React from 'react'
import { Button, Pagination, Tooltip } from '@mui/material'
import api, { operation } from '../../services/axios'
import { get } from 'lodash'
import Loading from '../../components/Loading'
import { cnpjCpfMask } from '../../utils/masks'

import { toast } from 'react-hot-toast'
import dayjs from '../../libs/dayjs'
import Solicitacoes, { SolicitacoesStatus } from './interfaces'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />
})

export type OrderBy = 'asc' | 'desc' | null
const SolicitacoesAcesso: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    // const [dateRange, setDateRange] = useState<Array<null | Date>>([null, null])
    // const [startDate, endDate] = dateRange
    const [solicitacoesStatus, setSolicitacoesStatus] =
        useState<SolicitacoesStatus>('all')
    // const [institutionSearch, setInstitutionSearch] = useState('')
    const [showAcceptsRequest, setShowAcceptsRequest] = useState(false)
    const [showRejectsRequest, setShowRejectsRequest] = useState(false)
    const [ordenarPorDataCriacao, setOrdenarPorDataCriacao] =
        useState<OrderBy>('desc')
    const [solicitacoes, setSolicitacoes] = useState<Solicitacoes[]>([])
    const [solicitacoesPage, setSolicitacoesPage] = useState(1)
    const [solicitacoesCount, setSolicitacoesCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [selectedId, setSelectedId] = useState<string>('')

    const getAccessRequests = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.post(
                    `/antecipacao/solicitacoes?page=${solicitacoesPage}`,
                    {
                        cnpj_cpf,
                        solicitacoesStatus,
                        ordenarPorDataCriacao,
                    }
                )
                const { solicitacoes, quantidadePaginas } = data

                setSolicitacoes(solicitacoes)
                setSolicitacoesCount(quantidadePaginas)

                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [ordenarPorDataCriacao, solicitacoesStatus, solicitacoesPage, cnpj_cpf])

    useEffect(() => {
        getAccessRequests()
    }, [getAccessRequests])

    function renderSolicitacoes() {
        return solicitacoes.map((solicitacao) => {
            return (
                <tr key={solicitacao.id}>
                    <td>
                        {dayjs(solicitacao.criadaAs).format(
                            'DD/MM/YYYY - HH:mm:ss'
                        )}
                    </td>
                    <td>{solicitacao.nomeOperador}</td>
                    <td>{cnpjCpfMask(solicitacao.documentoOperador)}</td>
                    {/* <td>10</td> */}
                    {/* <td>{aa}</td> */}
                    <td className="actions">
                        {solicitacao.status === 'Aguardando aceite' && (
                            <>
                                <form
                                    onSubmit={handleRejectsAccesss}
                                    id="form-rejects-request"
                                >
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowRejectsRequest(true)
                                            setSelectedId(solicitacao.id)
                                        }}
                                    >
                                        <Tooltip
                                            title="Recusar solicitação de acesso"
                                            placement="top"
                                        >
                                            <span>
                                                <MdOutlineBlock
                                                    size={22}
                                                    color="#333"
                                                />
                                            </span>
                                        </Tooltip>
                                    </button>
                                </form>
                                <form
                                    onSubmit={handleAcceptsRequest}
                                    id="form-accepts-request"
                                    className="actions"
                                >
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowAcceptsRequest(true)
                                            setSelectedId(solicitacao.id)
                                        }}
                                    >
                                        <Tooltip
                                            title="Aprovar solicitação de acesso"
                                            placement="top"
                                        >
                                            <span>
                                                <IoMdKey
                                                    size={22}
                                                    color="#333"
                                                />
                                            </span>
                                        </Tooltip>
                                    </button>
                                </form>
                            </>
                        )}
                    </td>
                    <td>
                        {solicitacao.status === 'Aceito' && (
                            <Tooltip title="Acesso liberado" placement="top">
                                <span>
                                    <MdLockOpen size={22} color="#333" />
                                </span>
                            </Tooltip>
                        )}

                        {solicitacao.status === 'Recusado' && (
                            <Tooltip title="Acesso recusado" placement="top">
                                <span>
                                    <MdLockOutline size={22} color="#333" />
                                </span>
                            </Tooltip>
                        )}
                    </td>
                </tr>
            )
        })
    }

    function handleOrderBy(order: string) {
        if (order === 'assinatura') {
            const order = ordenarPorDataCriacao === 'desc' ? 'asc' : 'desc'
            setOrdenarPorDataCriacao(order)
        }
        return
    }

    async function handleAcceptsRequest(e: FormEvent) {
        e.preventDefault()
        try {
            setShowAcceptsRequest(false)

            await api.patch(`/antecipacao/solicitacoes/${selectedId}/aceitar`, {
                cnpj_cpf,
                requestAccessId: selectedId,
            })
            if (solicitacoesStatus === 'all') {
                const newSolicitacoes: Solicitacoes[] = solicitacoes.map(
                    (solicitacao) => {
                        if (solicitacao.id === selectedId) {
                            return { ...solicitacao, status: 'Aceito' }
                        }
                        return solicitacao
                    }
                )
                setSolicitacoes(newSolicitacoes)
            } else {
                const newSolicitacoes = solicitacoes.filter(
                    (solicitacao) => selectedId !== solicitacao.id
                )
                setSolicitacoes(newSolicitacoes)
            }
            toast.success('Sucesso!')
        } catch (error) {
            toast.error('Ocorreu um erro ao tentar aprovar a solicitaçao.')
            setShowAcceptsRequest(false)
        }
    }

    async function handleRejectsAccesss(e: FormEvent) {
        e.preventDefault()
        try {
            setShowRejectsRequest(false)

            await api.patch(`/antecipacao/solicitacoes/${selectedId}/recusar`, {
                cnpj_cpf,
                requestAccessId: selectedId,
            })
            if (solicitacoesStatus === 'all') {
                const newSolicitacoes: Solicitacoes[] = solicitacoes.map(
                    (solicitacao) => {
                        if (solicitacao.id === selectedId) {
                            return { ...solicitacao, status: 'Recusado' }
                        }
                        return solicitacao
                    }
                )
                setSolicitacoes(newSolicitacoes)
            } else {
                const newSolicitacoes = solicitacoes.filter(
                    (solicitacao) => selectedId !== solicitacao.id
                )
                setSolicitacoes(newSolicitacoes)
            }

            toast.success('Sucesso!')
        } catch (error) {
            toast.error('Erro!')
            setShowRejectsRequest(false)
        }
    }

    return (
        <Container>
            <Filter>
                <div className="top-bar">
                    <h1>Solicitações de acesso</h1>
                    {/* <div className="right-side">
                        <div className="flex relative ">
                            <span className="cursor-pointer rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                                <MdOutlineSearch size={22} />
                            </span>
                            <input
                                type="text"
                                id="porCnpj_cpf"
                                name="porCnpj_cpf"
                                className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                value={institutionSearch}
                                onChange={(e) =>
                                    setInstitutionSearch(e.target.value)
                                }
                                placeholder="Procurar empresa..."
                            />
                        </div>
                    </div> */}
                </div>
                <div className="bottom-bar">
                    <RadioGroup
                        value={solicitacoesStatus}
                        onChange={(value: SolicitacoesStatus) =>
                            setSolicitacoesStatus(value)
                        }
                    >
                        <RadioGroup.Label className="text-2xl text-gray-900 sr-only">
                            Qual categoria de contrato você deseja filtrar?
                        </RadioGroup.Label>
                        <div className="select">
                            <RadioGroup.Option value="all">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Todas
                                    </Option>
                                )}
                            </RadioGroup.Option>

                            <RadioGroup.Option value="Aceito">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Aprovadas
                                    </Option>
                                )}
                            </RadioGroup.Option>

                            <RadioGroup.Option value="Aguardando aceite">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Pendentes de aprovação
                                    </Option>
                                )}
                            </RadioGroup.Option>

                            <RadioGroup.Option value="Recusado">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Recusadas
                                    </Option>
                                )}
                            </RadioGroup.Option>
                        </div>
                    </RadioGroup>
                    <div className="right-side">
                        {/* <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="Selecione um período de data"
                            className="flex-1 appearance-none border rounded-lg border-gray-300  py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            onChange={(update) => {
                                setDateRange(update)
                            }}
                            dateFormat="dd/MM/yyyy"
                        />
                        <button className="appearance-none border rounded-lg border-gray-300 py-1 px-2 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base">
                            <BsFilter size={23} />
                        </button> */}
                    </div>
                </div>
            </Filter>
            <SolicitacaoContainer>
                <Header>
                    <div className="left">
                        <div className="title">
                            <h2>Empresas</h2>
                        </div>
                    </div>
                </Header>

                {isLoading ? (
                    <Loading />
                ) : (
                    <Table>
                        <thead>
                            <tr>
                                <th
                                    onClick={(e) => handleOrderBy('assinatura')}
                                    className={
                                        ordenarPorDataCriacao === 'asc'
                                            ? 'order'
                                            : 'order desc'
                                    }
                                >
                                    Data de Criação{' '}
                                    <MdKeyboardArrowUp size={18} />
                                </th>
                                <th className="">Nome empresa</th>
                                <th>
                                    CNPJ/CPF <br />
                                </th>
                                {/* <th className="">Acessos</th> */}
                                <th className="">Ações</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>{renderSolicitacoes()}</tbody>
                    </Table>
                )}
            </SolicitacaoContainer>
            <div className="pagination">
                <Pagination
                    onChange={(e, value) => setSolicitacoesPage(value)}
                    page={solicitacoesPage}
                    count={solicitacoesCount}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                />
            </div>
            <Dialog
                open={showAcceptsRequest}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setShowAcceptsRequest(false)}
                aria-describedby="alert-accepts"
            >
                <DialogTitle>Aprovar solicitação de acesso</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-accepts">
                        Tem certeza que deseja aprovar está solicitação ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowAcceptsRequest(false)}>
                        Cancelar
                    </Button>
                    <Button type="submit" form="form-accepts-request">
                        Sim, aprovar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showRejectsRequest}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setShowRejectsRequest(false)}
                aria-describedby="alert-rejects"
            >
                <DialogTitle>Recusar solicitação de acesso</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-rejects">
                        Tem certeza que deseja recusar está solicitação ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowRejectsRequest(false)}>
                        Cancelar
                    </Button>
                    <Button type="submit" form="form-rejects-request">
                        Sim, recusar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default SolicitacoesAcesso
